'use strict';

import ApplyClass from './Utils/ApplyClass';
import Common from './Utils/Common';
import ControllerObject from './Controller/Controller';

import Header from './View/Header';
import Faq from './View/Faq';
import Speakers from './View/Speakers';
import DrawerNav from './View/DrawerNav';
import ArchiveExpansion from './View/archive-expansion';
import CrossfadeSlideshow from './View/CrossfadeSlideshow';
import Modal from './View/Modal';
import News from './View/News';
import FairIntroMarquee from './View/FairIntroMarquee';
import LazyBackground from './View/LazyBackground';

$(() => {
	const Controller = new ControllerObject();
	Common.addHtmlClass();

	// SP ドロワーナビ
	$('.btn--hamburger').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(DrawerNav, $e, [$e]);
	});

	// ヘッダー
	$('#kv').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(Header, $e, [$e, Controller]);
	});

	// セミナー登壇者 詳細トグル（SP）
	$('.section--speakers').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(Speakers, $e, [$e]);
	});

	// FAQ アコーディオン
	$('.list--faq').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(Faq, $e, [$e]);
	});

	// アーカイブギャラリー SP長押し拡大
	$('.block--gallery-grid').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ArchiveExpansion, $e, [$e]);
	});

	// KV/Footer クロスフェード
	$('.block--kv__bg, .block--footer-bg').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(CrossfadeSlideshow, $e, [$e]);
	});

	// 参加予定校モーダル
	$('[data-toggle=modal]').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(Modal, $e, [$e]);
	});

	// Pippa's Guardians BBSFJカテゴリーの最新情報
	$('.section--news .block--card-wrapper').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(News, $e, [$e]);
	});

	// フェア紹介 写真マーキー
	$('.block--photo-track').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(FairIntroMarquee, $e, [$e]);
	});

	// 街並み背景の遅延読み込み
	$('[data-lazy-bg]').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(LazyBackground, $e, [$e]);
	});

});
